<div class="flex flex-col gap-4 justify-center items-center h-full">
  <div class="font-semibold text-xl">Siden findes ikke</div>
  <div>
    <p-button label="Gå til forsiden" routerLink="/"></p-button>
  </div>
</div>
